<div class="modal-header">
    <h4 class="modal-title">Confirmation ?</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
    <p [ngStyle]="{
        color: (Dataa && Dataa.length > 0) ? 'red' : 'black',
        'font-weight': (Dataa && Dataa.length > 0) ? 'bold' : 'normal'
      }">{{ Message }}</p>
    <div class="card-header" *ngIf="Dataa && Dataa.length > 0">
        <div class="container" *ngIf="Dataa && Dataa.length > 0">
            <div class="row" *ngIf="Dataa && Dataa.length > 0">
                <!-- <div class="col-md-4">
                    <label class="small-light-label heading">WO.No.</label><br />
                    <label class="Label1">{{Dataa[0].WoNo}}</label>
                </div>
                <div class="col-md-4">
                    <label class="small-light-label heading">WO. Date</label><br />
                    <label class="Label1">{{Dataa[0].WoDate}}</label>
                </div> -->
                <div class="col-md-3">
                    <label class="small-light-label heading">Branch</label><br />
                    <label class="Label1">{{Dataa[0].BranchName}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Client</label><br />
                    <label class="Label1">{{Dataa[0].ClientName}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Site</label><br />
                    <label class="Label1">{{Dataa[0].SiteName}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Site Code</label><br />
                    <label class="Label1">{{Dataa[0].SiteCode}}</label>
                </div>
            </div>
            <hr>
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered"
                    *ngIf="Dataa && Dataa.length > 0">
                    <thead *ngIf="Dataa && Dataa.length > 0">
                        <tr *ngIf="Dataa && Dataa.length > 0">
                            <th scope="col">#</th>
                            <th scope="col">Entry No</th>
                            <th scope="col">WO.No.</th>
                            <th scope="col">WO.Date</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Duty</th>
                            <th scope="col">Shift</th>
                            <th scope="col">No Of Person</th>
                            <th scope="col">Reduction Date</th>
                            <th scope="col">Auto Entry</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="Dataa && Dataa.length > 0">
                        <tr *ngFor="let site of Dataa; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>{{site['EntryNo']}}</td>
                            <td>{{ site['WoNo'] }}</td>
                            <td>{{ site['WoDate'] }}</td>
                            <td>{{ site['DesignationName'] }}</td>
                            <td>{{ site['DutyName'] }}</td>
                            <td>{{ site['ShiftTitle'] }}</td>
                            <td>{{ site['NoOfPerson'] }}</td>
                            <td>{{ site['FromDate'] }}</td>
                            <td>{{ site['IsAutoReduction']?'Yes':'No' }}</td>
                            <td style="display: none;">{{ site['ToDate'] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">

    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="close(true)"><i class="bi bi-check"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Ok':'Loading...'}}</button>

    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>